<template>
    <div :style="cssProps">
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col">
                    <h1 class="text-white pt-3 px-3">หน้าจัดการสมาชิก</h1>
                    <p class="text-white pb-3 px-3">เพิ่ม แก้ไข ลบสมาชิก และแสดงตารางรายละเอียดสมาชิกทั้งหมดที่มีอยู่ภายในสาขา
                    </p>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--8 mb-5">
            <div class="row">
                <div class="col">
                    <div class="text-center" v-if="busy">
                        <BlockUI>
                            <div class="loader"></div>
                        </BlockUI>
                    </div>
                    <div class="card shadow py-5">
                        <div class="row justify-content-between">
                            <div class="col-12">
                                <h3 class="text-muted ml-4">ค้นหา</h3>
                                <div class="col-lg-12">
                                    <b-form-group class="mb-0">
                                        <div class="row">

                                            <div class="col-lg m-1">
                                                <input
                                                    type="text"
                                                    placeholder="ชื่อบัญชี"
                                                    class="form-control"
                                                    v-model="search.name"
                                                />
                                            </div>
                                            <div class="col-lg m-1">
                                                <div class="col-lg m-1">
                                                    <select class="form-control" v-model="search.type">
                                                        <option value="" disabled selected>กรุณาเลือกสถานะการสั่งซื้อ</option>
                                                        <option value="1">admin</option>
                                                        <option value="2">member</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="col-lg-3 m-1">
                                                <button class="btn btn-info btn-sm-res" @click="getSubAgentUserList">
                                                    <i class="fa fa-search"></i>ค้นหา
                                                </button>
                                                <button class="btn btn-info btn-sm-res" @click="addSubAccount">
                                                    <i class="fa fa-plus"></i>เพิ่มสมาชิก
                                                </button>
                                            </div>
                                        </div>
                                    </b-form-group>

                                    <div class="mt-5">
                                        <b-table
                                            ref="reportDelivery"
                                            show-empty
                                            responsive
                                            :items="ListData"
                                            :fields="fields"
                                            :per-page="search.perPage"
                                            :busy="busy"
                                            selectable
                                            select-mode="multi"
                                            class="scroll-bar-pop text-center"
                                            empty-text="ไม่มีข้อมูลผู้ใช้"
                                            empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
                                        >
                                            <template slot="type" slot-scope="data">
                                                <b-badge variant="status-parcel-success"
                                                    v-if="data.item.userType == 1"
                                                >
                                                    บัญชีหลัก
                                                </b-badge>
                                                <b-badge variant="status-parcel-success"
                                                    v-if="data.item.userType == 2"
                                                >
                                                    บัญชีย่อย
                                                </b-badge>
                                            </template>
                                            <template slot="state" slot-scope="data">
                                                <b-badge variant="status-parcel-success"
                                                         v-if="data.item.status == 1"
                                                >
                                                    เปิดใช้งาน
                                                </b-badge>
                                                <b-badge variant="status-parcel-danger"
                                                         v-if="data.item.status == 0"
                                                >
                                                    ปิดใช้งาน
                                                </b-badge>
                                            </template>
                                            <template slot="operate" slot-scope="data">
<!--                                                <button class="btn btn-sm btn-primary px-3">-->
<!--                                                    <i class="fas fa-rotate-180"></i>ตั้งรหัสผ่านใหม่-->
<!--                                                </button>-->
                                                <button class="btn btn-sm btn-info px-3" v-if="data.item.userType == 2" @click="editSubAccount(data.item)">
                                                    <i class="fas fa-edit"></i>แก้ไข
                                                </button>
                                                <button class="btn btn-sm btn-danger px-3" @click="deleteData(data)"  v-if="data.item.userType == 2">
                                                    <i class="fas fa-trash"></i>ลบ
                                                </button>
                                            </template>
                                        </b-table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

<!--        添加 编辑子账号-->
        <b-modal
            centered
            hide-footer
            v-model="subAccountVisible"
            size="md"
            :title="form.id ? 'แก้ไขบัญชี' : 'เพิ่มบัญชี'"
            @hide="closeSubAccountModal"
        >
            <b-form @submit="onSubmit">
                <b-form-group
                    id="input-group-1"
                    label="ชื่อสาขา"
                    label-for="input-1"
                >
                    <b-form-input
                        id="input-1"
                        :disabled="form.id"
                        v-model="form.name"
                        placeholder="กรอก"
                        required
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    id="input-group-2"
                    label="ชื่อสกุล"
                    label-for="input-1"
                >
                    <b-form-input
                        id="input-2"
                        v-model="form.mobile"
                        placeholder="กรอก"
                        required
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    id="input-group-3"
                    label="เบอร์โทรศัพท์"
                    label-for="input-1"
                >
                    <b-form-input
                        id="input-3"
                        v-model="form.password"
                        placeholder="กรอก"
                        type="password"
                        required
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    id="input-group-4"
                    label="อีเมล"
                    label-for="input-1"
                >
                    <b-form-input
                        id="input-4"
                        v-model="form.email"
                        placeholder="กรอก"
                        type="email"
                        required
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    id="input-group-5"
                    label="สถานะ"
                    label-for="input-1"
                    required
                >
                    <b-form-radio-group
                        required
                        v-model="form.status"
                        :options="options"
                        class="mb-3"
                        value-field="item"
                        text-field="name"
                        disabled-field="notEnabled"
                    ></b-form-radio-group>
                </b-form-group>
                <div class="d-flex justify-content-center mt-4">
                    <b-button
                        class="px-5"
                        type="submit"
                        variant="primary"
                    >
                        ยืนยันการส่งลิงก์
                    </b-button>
                </div>
            </b-form>
        </b-modal>


    </div>
</template>
<script>

import {hexToRgbA} from "@/plugins/hexColor";
import {addSubAccount, deleteSubAccount, getSubAgentUserList} from "@/api/subAccount";

export default {
    name: "TQM",
    data() {
        return {
            options: [
                { item: '0', name: 'ปิดใช้งาน' },
                { item: '1', name: 'เปิดใช้งาน' }
            ],
            form: {},
            subAccountVisible: false,
            ListData: [],
            busy: false,
            fields: [
                {key: "userName", label: "ชื่อบัญชี", sortable: false, class: "text-center"},
                {key: "userCode", label: "โค้ดสาขา", sortable: false, class: "text-center"},
                {key: "email", label: "อีเมล", sortable: false, class: "text-center"},
                {key: "type", label: "ประเภทบัญชี", sortable: false, class: "text-center"},
                {key: "state", label: "สถานะ", sortable: false, class: "text-center"},
                {key: "createTime", label: "วันที่สร้าง", sortable: false, class: "text-center"},
                {key: "operate", label: "ดำเนินงาน", sortable: false, class: "text-center"}
            ],
            search: {
                name: '',
                type: '',
            }
        }
    },
    created() {

    },
    mounted() {
        this.getSubAgentUserList()
    },
    methods: {
        editSubAccount(row) {
            console.log(row)
            this.form = row
            this.form.name = row.userName
            this.subAccountVisible = true
        },
        addSubAccount() {
            this.form = {}
            this.subAccountVisible = true
        },
        onSubmit(evt) {
            evt.preventDefault()
            console.log(this.form)
            let params = {
                agentId: this.$store.state.loginUser.agentId,
                email: this.form.email,
                id: this.form.id ? this.form.id : '',
                mobile: this.form.mobile,
                name: this.form.name,
                password: this.form.password,
                status: this.form.status
            }
            addSubAccount(params).then(res => {
                this.busy = true
                this.$bvModal.msgBoxOk("การดำเนินการสำเร็จ!", {
                    title: "SUCCESS",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "success",
                    okTitle: "ตกลง",
                    contentClass: "modal-success",
                    headerClass: "p-2 border-bottom-0",
                    footerClass: "p-2 border-top-0",
                    centered: true
                });
                this.getSubAgentUserList()
                this.closeSubAccountModal()
            }).finally(() => {
                this.busy = false
            })
        },
        closeSubAccountModal() {
            this.subAccountVisible = false
            this.form = {}
        },
        deleteData(row) {
            this.$bvModal
                .msgBoxConfirm(`คุณต้องการจะลบข้อมูลสมาชิก `, {
                    title: "กรุณายืนยัน",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: "ยืนยัน",
                    cancelTitle: "ยกเลิก",
                    //for P' OOOO
                    contentClass: "modal-confirm",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value) {
                        deleteSubAccount({
                            userId: row.item.id
                        }).then(res => {
                            this.getSubAgentUserList()
                            this.$bvModal.msgBoxOk("ลบบัญชีสำเร็จ!", {
                                title: "SUCCESS",
                                size: "sm",
                                buttonSize: "sm",
                                okVariant: "success",
                                okTitle: "ตกลง",
                                contentClass: "modal-success",
                                headerClass: "p-2 border-bottom-0",
                                footerClass: "p-2 border-top-0",
                                centered: true
                            });
                        })
                    }
                })
        },
        getSubAgentUserList() {
            this.busy = true
            getSubAgentUserList(this.search).then(res => {
                this.ListData = res.data
            }).finally(() => {
                this.busy = false
            })
        }
    },
    computed: {
        subAccount() {
            return subAccount
        },
        cssProps() {
            return {
                '--bg-hover-color': hexToRgbA('#11cdef', 0.7),
                '--bg-color': '#11cdef',
            }
        }
    }
};
</script>
<style scoped>

</style>
